module.exports = __webpack_public_path__ + "static/media/main idea.fdc0d2bd.mp3";